/**
 * A soft click, played for each click while read aloud is on, so a visitor
 * who is listening knows the click landed. Made on the spot with Web Audio
 * (a 50 ms falling tone), so there is no sound file to load. Silent, never
 * an error, where audio is not available.
 */

type AudioContextClass = typeof AudioContext;

let context: AudioContext | null = null;

export function tick(): void {
  try {
    const Ctor: AudioContextClass | undefined =
      window.AudioContext || (window as any).webkitAudioContext;
    if (!Ctor) return;
    if (!context) context = new Ctor();
    const ctx = context;
    // Created during a click, so it may start suspended until resumed.
    if (ctx.state === 'suspended' && typeof ctx.resume === 'function') {
      const resumed = ctx.resume();
      if (resumed && typeof resumed.catch === 'function')
        resumed.catch(() => undefined);
    }
    const now = ctx.currentTime;
    const tone = ctx.createOscillator();
    const volume = ctx.createGain();
    tone.type = 'sine';
    tone.frequency.setValueAtTime(1500, now);
    tone.frequency.exponentialRampToValueAtTime(500, now + 0.04);
    volume.gain.setValueAtTime(0.0001, now);
    volume.gain.exponentialRampToValueAtTime(0.12, now + 0.005);
    volume.gain.exponentialRampToValueAtTime(0.0001, now + 0.05);
    tone.connect(volume);
    volume.connect(ctx.destination);
    tone.start(now);
    tone.stop(now + 0.06);
  } catch (e) {
    // No sound is fine.
  }
}
